<template>
  <div class="card p-4 shadow-sm">
    <button class="btn btn-outline-secondary btn-sm mb-3" @click="$router.push('/inicio')">
      <i class="bi bi-arrow-left me-1"></i> Regresar
    </button>

    <h4 class="mb-3">Ingresos Hospedaje — Detallado</h4>

    <!-- Filtros -->
    <div class="row g-2 align-items-end mb-3">
      <div class="col-md-2">
        <label class="form-label small text-muted">Fecha Inicio</label>
        <input type="date" v-model="fechaInicio" class="form-control form-control-sm" />
      </div>
      <div class="col-md-2">
        <label class="form-label small text-muted">Hora inicio</label>
        <input type="time" v-model="horaInicio" class="form-control form-control-sm" />
      </div>
      <div class="col-md-2">
        <label class="form-label small text-muted">Fecha Fin</label>
        <input type="date" v-model="fechaFin" class="form-control form-control-sm" />
      </div>
      <div class="col-md-2">
        <label class="form-label small text-muted">Hora fin</label>
        <input type="time" v-model="horaFin" class="form-control form-control-sm" />
      </div>
      <div class="col-md-2">
        <label class="form-label small text-muted">Estado</label>
        <select v-model="filtroEstado" class="form-select form-select-sm">
          <option value="todos">Todos</option>
          <option value="0">Activos</option>
          <option value="1">Anulados</option>
        </select>
      </div>
      <div class="col-md-2 d-flex gap-1">
        <button class="btn btn-primary btn-sm flex-fill" @click="buscar" :disabled="cargando || !fechaInicio || !fechaFin">
          <span v-if="cargando" class="spinner-border spinner-border-sm me-1"></span>
          Buscar
        </button>
      </div>
    </div>

    <!-- Botones export -->
    <div class="d-flex gap-2 mb-3" v-if="reporte">
      <button class="btn btn-danger btn-sm" @click="exportar('pdf')"><i class="bi bi-file-pdf me-1"></i>PDF</button>
      <button class="btn btn-success btn-sm" @click="exportar('excel')"><i class="bi bi-file-earmark-excel me-1"></i>Excel</button>
    </div>

    <!-- Sumatorias -->
    <div v-if="reporte" class="row g-2 mb-3">
      <div class="col-auto">
        <div class="badge bg-secondary fs-6">Habitaciones: {{ reporte.totales.num_habitaciones }}</div>
      </div>
      <div class="col-auto">
        <div class="badge bg-info text-dark fs-6">Huéspedes: {{ reporte.totales.num_huespedes }}</div>
      </div>
      <div class="col-auto">
        <div class="badge bg-primary fs-6">Total Reservaciones: Q{{ numFmt(reporte.totales.total_reservaciones) }}</div>
      </div>
      <div class="col-auto">
        <div class="badge bg-success fs-6">Total Cobrado: Q{{ numFmt(reporte.totales.total_cobrado) }}</div>
      </div>
      <div class="col-auto">
        <div class="badge bg-warning text-dark fs-6">Comisión Tarjetas: Q{{ numFmt(reporte.totales.comision_tarjetas) }}</div>
      </div>
      <div class="col-auto">
        <div class="badge bg-dark fs-6">Gastos Generales: Q{{ numFmt(reporte.totales.total_gastos_generales) }}</div>
      </div>
    </div>

    <!-- Tabla -->
    <div v-if="reporte" class="table-responsive">
      <table class="table table-sm table-bordered align-middle text-center">
        <thead class="table-dark">
          <tr>
            <th>Hab.</th>
            <th>Huésped</th>
            <th>Huésp.</th>
            <th>Total Reserva</th>
            <th>Usuario</th>
            <th>Estado</th>
            <th>Método Pago</th>
            <th>Referencia</th>
            <th>Total</th>
            <th>Base</th>
            <th>Gastos</th>
            <th>IVA</th>
            <th>INGUAT</th>
            <th>Fecha/Hora</th>
            <th>FEL</th>
            <th>Fac. Cancelada</th>
            <th v-if="esContador">Editar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fila in reporte.data" :key="fila.id" :class="{ 'table-danger': fila.estado_pago === 'Anulado' }">
            <td>{{ fila.habitacion }}</td>
            <td class="text-start">{{ fila.huesped }}</td>
            <td>{{ fila.num_huespedes }}</td>
            <td>Q{{ numFmt(fila.total_reserva) }}</td>
            <td class="text-start small">{{ fila.usuario_pago || '—' }}</td>
            <td>
              <span class="badge" :class="fila.estado_pago === 'Activo' ? 'bg-success' : 'bg-danger'">
                {{ fila.estado_pago }}
              </span>
            </td>
            <td>{{ fila.metodo_pago }}</td>
            <td class="small">{{ fila.numero_referencia !== '—' ? fila.numero_referencia : '' }}{{ fila.numero_factura_manual !== '—' ? ' / ' + fila.numero_factura_manual : '' }}</td>
            <td class="fw-bold">Q{{ numFmt(fila.monto) }}</td>
            <td>Q{{ numFmt(fila.base) }}</td>
            <td>
              <input
                v-if="esAdminOContador"
                type="number"
                step="0.01"
                min="0"
                class="form-control form-control-sm text-end"
                style="width: 90px"
                :value="fila.gastos_generales"
                :disabled="guardandoGastos === fila.id || fila.estado_pago === 'Anulado'"
                @change="guardarGastos(fila, $event)"
              />
              <span v-else>{{ numFmt(fila.gastos_generales) }}</span>
            </td>
            <td>Q{{ numFmt(fila.iva) }}</td>
            <td>Q{{ numFmt(fila.inguat) }}</td>
            <td class="small">{{ fila.fecha_hora }}</td>
            <td>
              <button v-if="fila.fel_uuid" class="btn btn-sm btn-link p-0" @click="verFactura(fila.fel_uuid)">
                {{ fila.fel_serie }}-{{ fila.fel_numero }}
              </button>
              <span v-else class="text-muted">—</span>
            </td>
            <td>
              <span :class="fila.factura_cancelada === 'Sí' ? 'text-danger' : 'text-success'">
                {{ fila.factura_cancelada }}
              </span>
            </td>
            <td v-if="esContador">
              <button class="btn btn-outline-warning btn-sm" @click="abrirEditar(fila)" :disabled="fila.estado_pago === 'Anulado'">
                <i class="bi bi-pencil me-1"></i> Editar
              </button>
            </td>
          </tr>
          <tr v-if="!reporte.data.length">
            <td :colspan="esContador ? 17 : 16" class="text-muted">Sin registros para el período seleccionado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal editar pago (solo Contador) -->
    <div v-if="modalEditar" class="modal fade show d-block" style="background:rgba(0,0,0,0.5)">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Pago #{{ pagoEditar.id }}</h5>
            <button class="btn-close" @click="modalEditar = false"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Monto (Q)</label>
              <input type="number" v-model.number="pagoEditar.monto" class="form-control" min="0.01" step="0.01" />
            </div>
            <div class="mb-3">
              <label class="form-label">Nº Referencia</label>
              <input type="text" v-model="pagoEditar.numero_referencia" class="form-control" />
            </div>
            <div class="mb-3">
              <label class="form-label">Nº Factura Manual</label>
              <input type="text" v-model="pagoEditar.numero_factura_manual" class="form-control" />
            </div>
            <div class="mb-3">
              <label class="form-label">Justificación <span class="text-danger">*</span></label>
              <textarea v-model="pagoEditar.justificacion" class="form-control" rows="3"></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="modalEditar = false">Cancelar</button>
            <button class="btn btn-primary" @click="guardarEdicion" :disabled="guardando">
              <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal previsualización FEL -->
    <FelPreviewModal v-if="felUuidPreview" :uuid="felUuidPreview" @cerrar="felUuidPreview = null" />

    <!-- Toast -->
    <div v-if="toast.show" class="toast-container position-fixed top-0 end-0 p-3" style="z-index:1055">
      <div class="toast show text-white" :class="toast.tipo === 'success' ? 'bg-success' : 'bg-danger'">
        <div class="d-flex">
          <div class="toast-body">{{ toast.msg }}</div>
          <button class="btn-close btn-close-white me-2 m-auto" @click="toast.show = false"></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config/config.js';
import FelPreviewModal from '@/components/shared/FelPreviewModal.vue';

function mañana() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toLocaleDateString('en-CA');
}

export default {
  name: 'IngresosHospedaje',
  components: { FelPreviewModal },
  data() {
    return {
      fechaInicio: new Date().toLocaleDateString('en-CA'),
      fechaFin:    mañana(),
      horaInicio:  '08:00',
      horaFin:     '07:59',
      filtroEstado: 'todos',
      reporte: null,
      cargando: false,
      modalEditar: false,
      guardando: false,
      guardandoGastos: null,
      pagoEditar: {},
      felUuidPreview: null,
      toast: { show: false, msg: '', tipo: 'success' },
    };
  },
  computed: {
    esContador() {
      return this.$store.getters.getUser?.IdRol === 11;
    },
    esAdminOContador() {
      return [1, 11].includes(this.$store.getters.getUser?.IdRol);
    },
  },
  methods: {
    numFmt(v) {
      return Number(v || 0).toFixed(2);
    },
    async buscar() {
      if (!this.fechaInicio || !this.fechaFin) return;
      this.cargando = true;
      this.reporte  = null;
      try {
        const { data } = await axios.get(`${API_URL}/ingresos-hospedaje-detalle`, {
          params: {
            fecha_inicio: this.fechaInicio,
            fecha_fin:    this.fechaFin,
            hora_inicio:  this.horaInicio,
            hora_fin:     this.horaFin,
            estado:       this.filtroEstado,
          },
        });
        this.reporte = data;
      } catch (e) {
        this.mostrarToast('Error al obtener reporte', 'danger');
      } finally {
        this.cargando = false;
      }
    },
    async exportar(tipo) {
      const endpoint = tipo === 'pdf' ? 'ingresos-hospedaje-detalle-pdf' : 'ingresos-hospedaje-detalle-excel';
      const mime     = tipo === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const ext      = tipo === 'pdf' ? 'pdf' : 'xlsx';
      try {
        const res = await axios.get(`${API_URL}/${endpoint}`, {
          params: {
            fecha_inicio: this.fechaInicio,
            fecha_fin:    this.fechaFin,
            hora_inicio:  this.horaInicio,
            hora_fin:     this.horaFin,
            estado:       this.filtroEstado,
          },
          responseType: 'blob',
        });
        const link  = document.createElement('a');
        link.href   = URL.createObjectURL(new Blob([res.data], { type: mime }));
        link.download = `Ingresos_Hospedaje_${this.fechaInicio}_${this.fechaFin}.${ext}`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (e) {
        this.mostrarToast(`Error al generar ${tipo.toUpperCase()}`, 'danger');
      }
    },
    abrirEditar(fila) {
      this.pagoEditar = {
        id:                    fila.id,
        monto:                 fila.monto,
        numero_referencia:     fila.numero_referencia === '—' ? '' : fila.numero_referencia,
        numero_factura_manual: fila.numero_factura_manual === '—' ? '' : fila.numero_factura_manual,
        justificacion:         '',
      };
      this.modalEditar = true;
    },
    async guardarEdicion() {
      if (!this.pagoEditar.justificacion?.trim()) {
        this.mostrarToast('La justificación es obligatoria', 'danger');
        return;
      }
      this.guardando = true;
      try {
        await axios.put(`${API_URL}/ingresos-hospedaje/${this.pagoEditar.id}`, {
          Monto:               this.pagoEditar.monto,
          NumeroReferencia:    this.pagoEditar.numero_referencia,
          NumeroFacturaManual: this.pagoEditar.numero_factura_manual,
          justificacion:       this.pagoEditar.justificacion,
        });
        this.modalEditar = false;
        this.mostrarToast('Pago actualizado', 'success');
        await this.buscar();
      } catch (e) {
        this.mostrarToast(e.response?.data?.message || 'Error al actualizar', 'danger');
      } finally {
        this.guardando = false;
      }
    },
    mostrarToast(msg, tipo = 'success') {
      this.toast = { show: true, msg, tipo };
      setTimeout(() => (this.toast.show = false), 3500);
    },
    verFactura(uuid) {
      this.felUuidPreview = uuid;
    },
    async guardarGastos(fila, event) {
      const gastos = Number(event.target.value);
      this.guardandoGastos = fila.id;
      try {
        await axios.put(`${API_URL}/ingresos-hospedaje/${fila.id}/gastos-generales`, {
          GastosGenerales: gastos,
        });
        this.mostrarToast('Gastos generales actualizados', 'success');
        await this.buscar();
      } catch (e) {
        event.target.value = fila.gastos_generales;
        this.mostrarToast(e.response?.data?.message || 'Error al actualizar gastos generales', 'danger');
      } finally {
        this.guardandoGastos = null;
      }
    },
  },
  async mounted() {
    await this.buscar();
  },
};
</script>
